import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import languageReducer from "./features/languageSlice";
import cartReducer from "./features/cartSlice";
import authModalSlice from "./features/authModalSlice";
import expiredModalSlice from "./features/expiredModalSlice";
import globalLoadingSlice from "./features/globalLoadingSlice";
import appStateSlice from "./features/appStateSlice";
import userSlice from "./features/userSlice";
// import orderSlide from "./features/orderSlide";

/* ================================
   Persist Config
================================ */

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["cart", "user"],
};

const rootReducer = combineReducers({
  language: languageReducer,
  cart: cartReducer,
  authModal: authModalSlice,
  expiredModal: expiredModalSlice,
  globalLoading: globalLoadingSlice,
  appState: appStateSlice,
  // order: orderSlide,
  user: userSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
